import { useCallback, useEffect } from 'react';

import { AddOrUpdatePresetRequest } from '@scaleaq/sitecontrol-lib';
import { UseFormSetValue } from 'react-hook-form';

type PresetAxisName = keyof Pick<AddOrUpdatePresetRequest, 'distance' | 'depth' | 'pan' | 'tilt'>;

type UsePresetAxisArgs = {
  actual: number | null | undefined;
  enabled?: boolean;
  name: PresetAxisName;
  setValue: UseFormSetValue<AddOrUpdatePresetRequest>;
};

/** Clears the axis when it is excluded, and copies the live camera reading on apply. */
export const usePresetAxis = ({ actual, enabled = true, name, setValue }: UsePresetAxisArgs) => {
  const reading = typeof actual === 'number' && Number.isFinite(actual) ? actual : undefined;

  useEffect(() => {
    if (!enabled) {
      setValue(name, undefined);
    }
  }, [enabled, name, setValue]);

  const applyActual = useCallback(() => {
    if (reading === undefined) {
      return;
    }

    setValue(name, reading, { shouldDirty: true, shouldValidate: true });
  }, [name, reading, setValue]);

  return {
    actualValue: reading,
    applyActual,
  };
};
